// extracted by mini-css-extract-plugin
export default {"business-info":"business-info-box_business-info__UtV4y"};